import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import StylishNewInput from 'components/DesignSystems/New/StylishNewInput';
import { INPUT_STYLE } from 'components/MapPage/CorporateViewTabs/LayersTab/utils/constants';
import {
  useActualIncidentId,
  useGroupGuid,
} from 'components/IAP/hooks/commonHooks';
import { useCreateLayerFolderNodeMutation } from 'hooks/layerNode/useCreateLayerFolderNodeMutation';
import { useIsCommandCenter } from './utils/isCommandCenter';

type AddLayerFolderFormValues = {
  name: string;
  description: string;
};

export function AddLayerFolderModal() {
  const [show, setShow] = useState(false);

  const groupGuid = useGroupGuid();
  const {
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting },
  } = useForm<AddLayerFolderFormValues>({
    defaultValues: {
      name: '',
      description: '',
    },
  });
  const createLayerFolder = useCreateLayerFolderNodeMutation();
  const isCommandCenter = useIsCommandCenter();
  const actualIncidentId = useActualIncidentId();

  const handleClose = () => {
    setShow(false);
    reset();
  };

  const onSubmit = handleSubmit(async (data: AddLayerFolderFormValues) => {
    await createLayerFolder.mutateAsync({
      groupGuid: groupGuid,
      name: data.name,
      description: data.description,
      incidentId: isCommandCenter ? null : actualIncidentId,
    });

    handleClose();
  });

  return (
    <>
      <StylishNewButton
        type="button"
        className="button--secondary pe-auto"
        onClick={() => setShow(true)}
      >
        <SharedIcon iconName="add" size="sm" />
        Add category
      </StylishNewButton>

      <Modal show={show} onHide={handleClose} centered>
        <form onSubmit={onSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add category</Modal.Title>
          </Modal.Header>

          <Modal.Body className="d-grid gap-3">
            <Controller
              control={control}
              name="name"
              rules={{ required: 'Name is required' }}
              render={({ field }) => (
                <div>
                  <label
                    className="form-label mb-1"
                    htmlFor="add-category-name"
                  >
                    Name *
                  </label>
                  <StylishNewInput
                    id="add-category-name"
                    className="form-control"
                    {...field}
                    style={INPUT_STYLE}
                  />
                </div>
              )}
            />

            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <div>
                  <label
                    className="fw-bold mb-2 mt-3"
                    htmlFor="add-category-description"
                  >
                    Description
                  </label>
                  <textarea
                    id="add-category-description"
                    className="form-control"
                    rows={3}
                    style={INPUT_STYLE}
                    {...field}
                  />
                </div>
              )}
            />
          </Modal.Body>

          <Modal.Footer className="justify-content-start">
            <StylishNewButton
              type="submit"
              className="button--primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Saving…' : 'Save'}
            </StylishNewButton>
            <StylishNewButton
              type="button"
              className="button--secondary button--reverse"
              onClick={handleClose}
            >
              Cancel
            </StylishNewButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
